import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt, FaCog } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { languageHelper } from "../../../config/helperFunctions";
import DataTable from "../../../components/Website/DataTable";

function MyAddresses() {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    address_type: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
  });
  const [addresses, setAddress] = useState([]);
  // const [shouldUpdate, setShouldUpdate] = useState(false)

  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Name"),
      accessorKey: "address_type",
    },
    {
      header: languageHelper("Street Number"),
      accessorKey: "address_line_1",
    },
    {
      header: languageHelper("Building Number"),
      accessorKey: "address_line_2",
    },
    {
      header: languageHelper("Postal Code"),
      accessorKey: "postal_code",
    },
    {
      header: languageHelper("City"),
      accessorKey: "city",
    },
    {
      header: languageHelper("City Subdivision"),
      accessorKey: "state",
    },
    {
      header: languageHelper("Action"),
      cell: (row) => (
        <ActionDropdown
          refetchData={fetchAddresses}
          user={customer}
          id={row.row.original.id}
          data={row.row.original}
          setFormData={setFormData}
          setIsFormOpen={setIsFormOpen}
        />
      ),
    },
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.id) {
      axios
        .put(`${apiKey}/api/rms/customer/addresses/${formData.id}`, formData, {
          headers: {
            Authorization: `Bearer ${customer?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setFormData({
            address_type: "",
            address_line_1: "",
            address_line_2: "",
            city: "",
            state: "",
            postal_code: "",
            country: "",
          });
          fetchAddresses();
          setIsFormOpen(false);
        })
        .catch((err) => {
          toast.error(err.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } else {
      axios
        .post(`${apiKey}/api/rms/customer/addresses`, formData, {
          headers: {
            Authorization: `Bearer ${customer?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setFormData({
            address_type: "",
            address_line_1: "",
            address_line_2: "",
            city: "",
            state: "",
            postal_code: "",
            country: "",
          });
          fetchAddresses();
          setIsFormOpen(false);
        })
        .catch((err) => {
          toast.error(err.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const fetchAddresses = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/customer/addresses`, {
        headers: {
          Authorization: `Bearer ${customer?.token}`,
        },
      })
      .then((res) => {
        setAddress(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [customer?.token]);

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);
  return (
    <div className="my-16">
      <div className="flex justify-end">
        <button
          onClick={() => setIsFormOpen(true)}
          className="bg-w-btn text-w-btn-text px-4 py-1 rounded text-center"
        >
          Add Address
        </button>
      </div>
      <div className="mt-4 relative overflow-x-auto shadow-md sm:rounded-lg">
        <DataTable columns={columns} data={addresses} />
      </div>
      {isFormOpen && (
        <AddAddressForm
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          setIsFormOpen={setIsFormOpen}
        />
      )}
    </div>
  );
}

function AddAddressForm(props) {
  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, []);
  return (
    <div
      className="grid place-items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-[100] bg-black bg-opacity-50 backdrop-blur-lg fade-in"
      onClick={() => props.setIsFormOpen(false)}
    >
      <div
        className="bg-white max-w-lg w-full py-4 px-8 mx-auto rounded-lg fade-in-down"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={props.handleSubmit}>
          <div className="">
            <div>
              <label
                htmlFor="name"
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("Name")}
              </label>
              <input
                id="name"
                type="text"
                className="border rounded w-full h-9 px-2"
                name="address_type"
                value={props.formData.address_type}
                onChange={props.handleChange}
              />
            </div>
            <div>
              <label
                htmlFor=""
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("City")}
              </label>
              <input
                type="text"
                className="border rounded w-full h-9 px-2"
                name="city"
                value={props.formData.city}
                onChange={props.handleChange}
              />
            </div>
            <div>
              <label
                htmlFor=""
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("City Subdivision")}
              </label>
              <input
                type="text"
                className="border rounded w-full h-9 px-2"
                name="state"
                value={props.formData.state}
                onChange={props.handleChange}
              />
            </div>
            <div>
              <label
                htmlFor=""
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("Postal Code")}
              </label>
              <input
                type="text"
                className="border rounded w-full h-9 px-2"
                name="postal_code"
                value={props.formData.postal_code}
                onChange={props.handleChange}
              />
            </div>
            <div>
              <label
                htmlFor=""
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("Country")}
              </label>
              <input
                type="text"
                className="border rounded w-full h-9 px-2"
                name="country"
                value={props.formData.country}
                onChange={props.handleChange}
              />
            </div>
            <div>
              <label
                htmlFor=""
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("Street Number")}
              </label>
              <input
                type="text"
                className="border rounded w-full h-9 px-2"
                name="address_line_1"
                value={props.formData.address_line_1}
                onChange={props.handleChange}
              />
            </div>
            <div>
              <label
                htmlFor=""
                className="text-w-bg text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2"
              >
                {languageHelper("Building Number")}
              </label>
              <input
                type="text"
                className="border rounded w-full h-9 px-2"
                name="address_line_2"
                value={props.formData.address_line_2}
                onChange={props.handleChange}
              />
            </div>
          </div>
          <div className="my-4 flex justify-between gap-4">
            <button className="bg-w-btn text-w-btn-text w-full px-2 py-1 rounded text-center">
              {languageHelper("Submit")}
            </button>
            <button
              onClick={() => props.setIsFormOpen(false)}
              type="button"
              className="bg-w-btn text-w-btn-text w-full px-2 py-1 rounded text-center"
            >
              {languageHelper("Cancel")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ActionDropdown({
  id,
  user,
  refetchData,
  data,
  setFormData,
  setIsFormOpen,
}) {
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/customer/addresses/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refetchData(); // Refetch data after successful delete
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-w-btn" />
          <IoIosArrowDown className="text-w-btn" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <button
            onClick={() => {
              setFormData(data);
              setIsFormOpen(true);
              setShowDropDown(false);
            }}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> Edit </p>
          </button>
          <button
            onClick={() => setShowDelModal(true)}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaTrashAlt />
            <p> Delete </p>
          </button>
        </div>
      </div>
      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-50"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-w-bg font-semibold text-xl text-center">
                Alert!
              </h1>
              <p className="text-center text-gray-700">Are you sure?</p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-w-btn text-w-btn-text font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                No
              </button>
              <button
                onClick={handleDelete}
                className="bg-w-btn text-w-btn-text font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MyAddresses;
